export default {"src":"/_next/static/media/gray-furniture.199bf034.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};